import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: #2c2c22\n  border-radius: 8px;\n  position: absolute;\n  left: auto;\n  right: 30px;\n  top: -27px;\n  z-index: 1;\n  &::after{\n    content: '';\n    position: absolute;\n    left: 100%;\n    top: 40%;\n    border-style: solid;\n    border-width: 7px 0 7px 7px;\n    border-color: transparent transparent transparent #2c2c22;\n  }\n\n  ul {\n    margin: 0;\n    list-style-type: none;\n    display: flex;\n    flex-direction: column;\n    font-style: normal;\n    font-weight: normal;\n    border-radius: 4px;\n    padding: 1rem;\n    line-height: ", ";\n    align-items: flex-start;\n\n    li {\n      cursor: pointer;\n      white-space: nowrap;\n      color: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  right: 10px;\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled } from "@styles";
export var Wrapper = styled.div(_templateObject());
export var Content = styled.div(_templateObject2(), function (props) {
  return props.theme.typography.baseLineHeight;
}, function (props) {
  return props.theme.colors.white;
});